module.exports = __webpack_public_path__ + "static/media/pro-freelancer-1.848586a1.webp";